import { Component, Input } from "@angular/core";
import { StatusBadgeConfig } from "@shared/models";

@Component({
  selector: "app-status-badge",
  standalone: true,
  imports: [],
  templateUrl: "./status-badge.component.html",
  styleUrl: "./status-badge.component.scss",
})
export class StatusBadgeComponent {
  @Input() status: StatusBadgeConfig = { class: "status info", icon: "pi pi-spin pi-sync", text: "Loading" };
}
